<template>
  <div>
    <vs-row vs-align="center"
            vs-type="flex"
            vs-justify="end"
            class="pb-4"
            vs-w="12">
      <vs-button @click="showUploadPopup=true">neues Bild hochladen</vs-button>
    </vs-row>
    <gallery :images="images" :index="index" @close="index = null"></gallery>
    <div
      class="image"
      v-for="(image, imageIndex) in images"
      :key="imageIndex"
      @click.self="index = imageIndex"
      :style="{ backgroundImage: 'url(' + image + ')', width: '300px', height: '200px' }"
    >
      <vs-button
        @click="onDelete"
        color="danger"
        type="filled"
        class="m-2"
        icon-pack="feather"
        icon="icon-trash"/>
    </div>
    <!--    file upload popup-->
    <vx-modal title="neues Bild hochladen" :active.sync="showUploadPopup"  v-if="showUploadPopup" detach>
      <vs-row vs-justify="center"
              vs-type="flex">
        <vs-row vs-justify="center"
                class="pb-10"
                vs-type="flex">
          <span>wählen Sie das Bild aus, um es hochzuladen</span>
        </vs-row>
        <vs-row vs-justify="center"
                class="pb-10"
                vs-type="flex">
          <input multiple ref="imageInput" type="file" accept="image/*" @change="onFileChanged">
        </vs-row>
        <vs-button @click="onUpload">hochladen</vs-button>
      </vs-row>
    </vx-modal>
    <!--    file upload popup-->
  </div>
</template>
<script>
  import VueGallery from 'vue-gallery';
  import axios from "../axios";

  export default {
    data: function () {
      return {
        // gallery
        images: [
          'https://cdn.pixabay.com/photo/2015/06/19/21/24/the-road-815297__340.jpg',
          'https://ethz.ch/en/news-and-events/media-information/images/_jcr_content/par/twocolumn_446922753/par_left/fullwidthimage/image.imageformat.twocolumn.1954474593.jpg',
          'https://cdn.pixabay.com/photo/2015/06/19/21/24/the-road-815297__340.jpg',
          'https://cdn.pixabay.com/photo/2015/06/19/21/24/the-road-815297__340.jpg',
        ],
        index: null,
        // popup
        showUploadPopup: false,
        isFileUploadDisabled: true,
        selectedFile: null
      };
    },
    methods: {
      onFileChanged(event) {
        if (event.target.files.length > 5) {
          alert('max image number is 5 images')
          const input = this.$refs.imageInput
          input.type = 'text'
          input.type = 'file'
          return
        }
        const file = event.target.files[0]
      },
      onUpload() {
        // upload file
        const formData = new FormData()
        formData.append('myFile', this.selectedFile, this.selectedFile.name)
        axios.post('my-domain.com/file-upload', formData, {
          onUploadProgress: progressEvent => {
          }
        })
      },
      onDelete() {
        this.$vs.dialog({
          color: "danger",
          title: `Sind Sie sicher?`,
          text: 'Sind Sie sicher, dass Sie das Bild löschen möchten?',
          accept: this.acceptDelete,
          acceptText: 'JA'
        })
      },
      acceptDelete() {
        this.$toast.error('Bild gelöscht')
      }
    },
    components: {
      'gallery': VueGallery
    },
  }
</script>

<style scoped>
  .image {
    float: left;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    border: 1px solid #ebebeb;
    margin: 5px;
  }
</style>
